import { observer } from 'mobx-react';
import { orderProductModalStore } from '../../store/orderProductModalStore';
import ProductExclusions from '../ProductExclusions/ProductExclusions';
import ProductModifiers from '../ProductModifiers/ProductModifiers';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const ProductSelectorsBlock: React.FC = observer((): JSX.Element | null => {
  if (!orderProductModalStore.product) return null;

  return (
    <ScrollableBlock showScrollbar scrollbarSize="small" className="product-block mb-6 my-lg-5" scrollClassName="flex-1 pb-1 px-6 px-lg-5">
      <ProductModifiers />
      <ProductExclusions />
    </ScrollableBlock>
  );
});

export default ProductSelectorsBlock;
